<template>
  <div>
    <el-dialog v-if="showDialog" title="Cập nhật danh sách ghim" width="500px" :visible.sync="showDialog"
               :close-on-click-modal="false" @close="closeDialog()"
               :destroy-on-close="true">
      <div>
        <div class="divider-custom-zalo mb-3" style="margin-top: -30px;margin-right:-20px;margin-left: -20px " />
        <div class="text-center text-normal text-break">Đã đạt giới hạn 3 ghim. Ghim cũ dưới đây sẽ được bỏ để cập nhật
          nội dung mới.
        </div>
        <div v-if="!showAllInDialog" class="d-flex align-items-center mt-3 py-1 px-1 rounded-1"
             style="border: 1px solid #e0e4e8;">
          <div>
            <i class="el-icon-chat-line-round ms-3 me-3" style="  font-size: 24px; color:#005ae0;"></i>
          </div>
          <div class="d-flex flex-1 flex-column ">
            <div class="fw-semibold ">Tin nhắn</div>
            <div v-if="![49,32,44,38].includes(pinMessages[2].msg_type)">
              <el-tooltip class="item" effect="dark" :content="getContentPinMessage(pinMessages[2])"
                          placement="top-start">
                <div class="text-1-line-replied text-break"
                     style="display: inline-block;white-space:pre-line;color: #7589A3;">
                  {{ getContentPinMessage(pinMessages[2]) }}
                </div>
              </el-tooltip>
            </div>
            <div v-else class="d-flex my-1 ">
              <el-image class="rounded-2 me-2" :src="getHref(pinMessages[2])"
                        style="object-fit: cover;height: 24px;width: 24px" />
              <a :href="getHref(pinMessages[2])" style="white-space:pre-line" target="_blank"
                 class="flex-1 text-normal align-self-end text-break text-1-line-replied ">{{ getThumb(pinMessages[2])
                }}</a>
            </div>
          </div>
          <div class="pin px-2 py-1 rounded-1 text-center pointer me-2 fw-semibold" style="color: #0068ff"
               @click="showAllInDialog=true"> Thay đổi
          </div>
        </div>
        <div v-else class="rounded-1 mt-3 " style="border: 1px solid #e0e4e8;">
          <div v-for="(item,index) in pinMessages" :key="index">
            <div @click.stop.prevent="selectItem(item)" class="d-flex pin py-1 pointer">
              <div class="align-self-center">
                <i class="el-icon-chat-line-round  ms-3 me-3 " style=" font-size: 24px; color:#005ae0;" /></div>
              <div class="d-flex flex-1 flex-column " style="width : 100%;">
                <div class="fw-semibold ">Tin nhắn</div>
                <div v-if="![49,32,44,38].includes(item.msg_type)">
                  <el-tooltip class="item" effect="dark" :content="getContentPinMessage(item)"
                              placement="top-start">
                    <div class="text-1-line-replied text-break"
                         style="display: inline-block;white-space:pre-line;color: #7589A3;">
                      {{ getContentPinMessage(item) }}
                    </div>
                  </el-tooltip>
                </div>
                <div v-else class="d-flex my-1">
                  <el-image class="rounded-2 me-2" :src="getHref(item)"
                            style="object-fit: cover;height: 24px;width: 24px" />
                  <a :href="getHref(item)" style="white-space:pre-line" target="_blank"
                     class=" flex-1 text-normal align-self-end text-break text-1-line white-sc">{{ getThumb(item)
                    }}</a>
                </div>
              </div>
              <div class="me-3 pointer align-self-center">
                <input style="margin: 0" type="checkbox" :checked="checkSelected(item)"
                       :id="'checkbox'+item.client_msg_id" />
                <label :for="'checkbox'+item.client_msg_id"></label>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-3 fw-semibold">
          <span class="edit-button font-size-16 me-3 rounded-2  pointer py-2 px-3" @click="closeDialog()">Hủy</span>
          <span class="share-button font-size-16 rounded-2 pointer py-2 px-3" @click="actionUpdate()">Cập nhật</span>
        </div>

      </div>
    </el-dialog>
    <div v-if="pinMessages.length>0">
      <div class="d-flex position-relative"
           style="max-height:52px; min-height: 52px;  border-bottom: 1px solid #e0e4e8; ">
        <div class="align-self-center">
          <i class="el-icon-chat-line-round  ms-3 me-3 "
             style="  font-size: 24px; color:#005ae0;" /></div>
        <div v-if="!isShowAllPinMessages" class="d-flex text-normal w-100 pin-message">
          <div class="d-flex flex-1 justify-content-between flex-column">
            <div class="fw-semibold">Tin nhắn</div>
            <div v-if="![49,32,44,38].includes(pinMessages[0].msg_type)">
              <el-tooltip class="item" effect="dark" :content="getContentPinMessage(pinMessages[0])"
                          placement="top-end">
                <div class="text-1-line-replied text-break my-1"
                     style="white-space:pre-line;color: #7589A3;">
                  {{ getContentPinMessage(pinMessages[0]) }}
                </div>
              </el-tooltip>
            </div>

            <div v-else class="d-flex my-1 ">
              <el-image class="rounded-2 me-2" :src="getHref(pinMessages[0])"
                        style="object-fit: cover;height: 24px;width: 24px" />
              <a :href="getHref(pinMessages[0])" style="white-space:pre-line" target="_blank"
                 class="flex-1 text-normal align-self-end text-break text-1-line-replied ">{{ getThumb(pinMessages[0])
                }}</a>
            </div>
          </div>
          <div class="me-3 pointer align-self-center">
            <el-popover
              :visible-arrow="false"
              placement="bottom"
              width="160"
              v-model="visible"
            >
              <div class="font-size-14 " style="margin: -7px -12px -7px -12px;">
                <div class="pointer pin ps-3 pe-2 py-2" v-if="showCopy(pinMessages[0])"
                     @click="actionCopy(pinMessages[0])">
                  Copy
                </div>
                <div class="pointer pin ps-3 pe-2 py-2" style="color: #d91b1b" @click="unPin(pinMessages[0])">
                  Bỏ ghim
                </div>
              </div>
              <i slot="reference"
                 class="pin icon-more el-icon-more font-size-16 pointer p-2 text-center align-self-center"
                 @click="open()"
                 style="border-radius: 999px;opacity: 0.8" />
            </el-popover>
          </div>
          <div v-if="pinMessages.length > 1" @click.stop="openPinMessageDropdown()"
               class="pin text-normal text-info me-2 fw-semibold text-center align-self-center rounded-2 me-2 pointer "
               style="padding:2px 4px 2px 4px;flex-shrink: 0; border:1px solid #005ae0;  color: #005ae0;">
            {{ pinMessages.length - 1 }} ghim khác <i class="el-icon-caret-bottom "></i></div>
        </div>
        <el-collapse-transition>
          <div v-show="isShowAllPinMessages" id="show-all-pinMessage" class="position-absolute w-100"
               v-click-outside="closePinMessage"
               style="z-index: 999;background-color: white">
            <div>
              <div class="d-flex py-2 justify-content-center align-items-center " style="background-color: #EAEDF0">
                <div class="ms-2 "> Danh sách ghim ({{ pinMessages.length }})</div>
                <div style="margin-left: auto" class="me-2 pointer" @click.stop="closePinMessage()"> Thu gọn <i
                  class="el-icon-caret-top" style="color: #005ae0;font-size: 15px;transition: 0.5s ease"
                  v-bind:style="isShowAllPinMessages?'transform: rotate(180deg)':''" /></div>
              </div>
              <div v-for="(item,index) in pinMessages" :key="index">
                <div class="d-flex pin py-1 pointer">
                  <div class="align-self-center"><i class="el-icon-chat-line-round  ms-3 me-3 "
                                                    style="  font-size: 24px; color:#005ae0;" /></div>
                  <div class="d-flex flex-1 flex-column " style="width : 100%;">
                    <div class="fw-semibold ">Tin nhắn</div>
                    <div v-if="![49,32,44,38].includes(item.msg_type)">
                      <el-tooltip class="item" effect="dark" :content="getContentPinMessage(item)"
                                  placement="top-start">
                        <div class="text-1-line-replied text-break"
                             style="display: inline-block;white-space:pre-line;color: #7589A3;">
                          {{ getContentPinMessage(item) }}
                        </div>
                      </el-tooltip>
                    </div>
                    <div v-else class="d-flex my-1">
                      <el-image class="rounded-2 me-2" :src="getHref(item)"
                                style="object-fit: cover;height: 24px;width: 24px" />
                      <a :href="getHref(item)" style="white-space:pre-line" target="_blank"
                         class=" flex-1 text-normal align-self-end text-break text-1-line white-sc">{{ getThumb(item)
                        }}</a>
                    </div>

                  </div>
                  <div class="me-3 pointer align-self-center">
                    <el-popover
                      :visible-arrow="false"
                      placement="bottom"
                      width="160"
                      v-model="item.visible" trigger="manual"
                    >
                      <div class="font-size-14 " style="margin: -7px -12px -7px -12px;">
                        <div class="pointer pin ps-3 pe-2 py-2" v-if="showCopy(item)" @click="actionCopy(item)">
                          Copy
                        </div>
                        <div class="pointer pin ps-3 pe-2 py-2" style="color: #d91b1b" @click="unPin(item)">
                          Bỏ ghim
                        </div>
                      </div>
                      <i slot="reference"
                         class=" el-icon-more font-size-16 pointer p-2 text-center align-self-center"
                         @click="openPopup(item)"
                         style="border-radius: 999px;opacity: 0.8" />
                    </el-popover>
                  </div>

                </div>
                <div class="divider-custom-zalo "></div>
              </div>
            </div>
          </div>
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>

<script>
import { COMMON } from "../../lib/Common";

export default {
  name: "PinMessages",
  props: {
    pinMessages: {
      type: Array,
      default() {
        return [];
      }
    },
    conversation: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      showAllInDialog: false,
      isShowAllPinMessages: false,
      isShowPopUpMore: false,
      visible: false,
      showDialog: false,
      selectedItems: [],
      selectedNeedPin: {}
    };
  },
  methods: {
    closeDialog() {
      this.selectedItems = [];
      this.selectedNeedPin = {};
      this.showDialog = false;
      this.showAllInDialog = false;
    },
    selectItem(item) {
      const index = this.selectedItems.indexOf(item);
      if (index > -1) {
        this.selectedItems.splice(index, 1);
      } else {
        this.selectedItems.push(item);
      }
    },
    checkSelected(item) {
      return this.selectedItems.some(s => s.client_msg_id === item.client_msg_id);
    },
    async actionUpdate() {
      if (this.showAllInDialog) {
        if (this.selectedItems.length === 0) {
          return this.alert("error", "Vui lòng chọn ghim cần gỡ");
        } else {
          for (const s of this.selectedItems) {
            await this.unPin(s);
          }
          this.pinMessages.filter(x => this.selectedItems.map(s => s.client_msg_id).includes(x.client_msg_id)).forEach(x => this.pinMessages.splice(this.pinMessages.indexOf(x), 1));
        }
      } else {
        await this.unPin(this.pinMessages[2]);
        const index = this.pinMessages.indexOf(this.pinMessages[2]);
        if (index > -1) {
          this.pinMessages.splice(index, 1);
        }
      }
      this.showAllInDialog = false;
      this.pinMessage(this.selectedNeedPin);
      this.showDialog = false;
    },
    pinMessage(message) {
      if (this.pinMessages.length > 2) {
        this.showDialog = true;
        this.selectedNeedPin = message;
        return;
      }
      let request = {
        group: this.conversation.group,
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        conversationId: this.conversation.toId,
        clientMsgId: message.cliMsgId,
        globalMsgId: message.id.msgId,
        senderId: message.id.uidFrom !== "0" ? message.id.uidFrom : this.conversation.accountId,
        senderName: this.getAccountName(this.app.accounts.find(s => s.accountId === this.conversation.accountId)),
        msgType: this.getMsgType(message),
        message: this.getMessageToPin(message)
      };
      if (this.getMessageToPin(message) === 46) {
        request.extra = JSON.parse(message).params;
      }
      this.$http.post("/api/message/pin", request).then(resp => {
        let data = resp.data;
        if (data.error_code === 0) return this.alert("success", "Ghim tin nhắn thành công");
        if (data.error_code === 315) return this.alert("error", "Yêu cầu thực hiện không thành công vì bạn hoặc người này đã chặn nhau");
        // if (data.error_code === 268) return this.alert("error", "dang full");
      });
      this.selectedItems = [];
      this.selectedNeedPin = {};
    },
    open() {
      this.isShowPopUpMore = true;
    },
    openPopup(item) {
      this.isShowPopUpMore = true;
      item.visible = !item.visible;
    },
    async unPin(message) {
      this.visible = false;
      let request = {
        accountId: this.conversation.accountId,
        conversationId: this.conversation.toId,
        topicType: message.type,
        topicId: message.id,
        group: this.conversation.group
      };
      await this.$http.post("/api/message/unpin", request).then((resp) => {
        if (resp.data.error_code !== 0) {
          this.alert("error", "Không thể bỏ ghim tin nhắn này");
        }
      }).finally(() => message.visible = false);
    },
    copy(message) {
      let code = message.content;
      const el = document.createElement("textarea");
      el.value = code;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      message.visiblePopup = false;
    },
    actionCopy(pinMessage) {
      if (pinMessage.msgType === COMMON.WEBCHAT) {
        this.copy(pinMessage);
        this.isShowPopUpMore = false;
      }
    },
    showCopy(pinMessage) {
      return [COMMON.WEBCHAT].includes(pinMessage.msgType);
    },
    openPinMessageDropdown() {
      this.isShowAllPinMessages = true;
      this.$emit("createOverScreen");
    },
    closePinMessage() {
      this.isShowAllPinMessages = false;
      this.pinMessages.forEach(s => s.visible = false);
      this.$emit("removeOverScreen");

    },
    getHref(item) {
      if (item.thumb !== undefined && item.thumb !== null && item.thumb !== "") {
        return item.thumb;
      } else {
        return item.title;
      }
    },
    getThumb(message) {
      if (message.msg_type === 38) {
        return "Danh thiếp:  " + message.title;
      } else {
        return message.thumb;
      }
    },


    getContentPinMessage(message) {
      switch (message.msg_type) {
        case 1: {
          return message.title;
        }
        case 46: {
          return message.title;
        }
        case 31: {
          return "[Ghi âm]";
        }
        case 43: {
          return message.title;
        }
        case 36: {
          return "Sticker";
        }
      }
    }
  }
};
</script>

<style scoped>
.share-button:hover {
  background-color: #0A58C0;
}

.share-button {
  color: #fff;
  background-color: #0068FF;
}

.edit-button:hover {
  background-color: #b6bec9;
}

.edit-button {
  background-color: #eaedf0;
  /*margin-left: auto;*/
}

label {
  background-color: #fff;
  border: 3px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  min-height: 21px;
  left: 0;
  position: relative;
  top: 50%;
  max-width: 21px;
  min-width: 21px;
  max-height: 21px;
}

label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: "";
  height: 6px;
  left: 3px;
  opacity: 0;
  position: absolute;
  top: 4px;
  transform: rotate(-45deg);
  width: 10px;
}

input[type="checkbox"] {
  visibility: hidden;
}

input[type="checkbox"]:checked + label {
  background-color: #0068ff;
  border-color: #0068ff;
}

input[type="checkbox"]:checked + label:after {
  opacity: 1;
}
</style>